export const nachaLabels = {
     statuses: [
        { name: "Confirmed", id: 6 },
        { name: "Rejected", id: 5 },
        { name: "Not selected", id: 4 },
      ],
      hsaStatuses: [
        { name: "Confirmed", id: 6 },
        { name: "Rejected", id: 5 },
        { name: "Not selected", id: 1 },
      ],
      nachaTypes:[
          {id:1, name:"Ameriflex ACH(Deposit)"},
          {id:2, name:"Ameriflex ACH(Debit)"},
          {id:3, name:"HSA Omnibus(Deposit)"},
          {id:4, name:"HSA Omnibus(Debit)"},
          {id:5, name:"Cobra ACH(Debit)"}
       ],
      rejectOptions: [
        { id: "R01", name: "R01 - Insufficient Funds" },
        { id: "R02", name: "R02 - Account Closed" },
        {
          id: "R03",
          name: "R03 - Unable to Locate Account",
        },
        {
          id: "R04",
          name: "R04 - Invalid Account Number",
        },
        {
          id: "R07",
          name: "R07 - Authorization Revoked by Customer",
        },
        { id: "R08", name: "R08 - Payment Stopped" },
        { id: 7, id: "R16", name: "R16 - Account Frozen" },
        {
          id: "R20",
          name: "R20 - Non Transaction Account",
        },
      ],
      allStatuses:[
        {id: 4, name: "Not selected"},
        {id: 5, name: "Rejected"},
        {id: 6, name: "Confirmed"},
        {id: 7, name: "Transaction Renachaed"},
        {id: 8, name: "Transaction Reversed"},
        {id: 9, name: "Transaction Reverse Failed"},
        {id: 10, name: "Manually Reversed"},

      ]
 }





// WEBPACK FOOTER //
// ./src/finance/nacha-labels.js